import { releaseWithMarketing } from './releaseWithMarketing';
import { releaseWithoutMarketing } from './releaseWithoutMarketing';
import { marketingMoment } from './marketingMoment';
import { offerPriceProgram } from './offerPriceProgram';
import { priceChangesAndOffers } from './priceChangesAndOffers';
import { policyChange } from './policyChange';
import { keyDate } from './keyDate';
import { events } from './events';
import { FormConfig } from './types';

// Combine all form fields into a single record
export const MOCK_FORM_FIELDS: Record<string, FormConfig> = {
  'release-with-marketing': releaseWithMarketing,
  'release-without-marketing': releaseWithoutMarketing,
  'marketing-moment': marketingMoment,
  'offer-price-program': offerPriceProgram,
  'Price Changes and Offers': priceChangesAndOffers,
  'policy-change': policyChange,
  'key-date': keyDate,
  event: events
};

export * from './releaseWithMarketing';
export * from './releaseWithoutMarketing';
export * from './marketingMoment';
export * from './offerPriceProgram';
export * from './priceChangesAndOffers';
export * from './policyChange';
export * from './keyDate';
export * from './events';
